(() => {
    const initNutritionDrawers = (scope = document) => {
      scope.querySelectorAll('[data-main-product-v2-nutrition-open]').forEach((opener) => {
        if (opener.dataset.mainProductV2NutritionBound === 'true') return;

        const drawerId = opener.getAttribute('aria-controls');
        const drawer = drawerId ? document.getElementById(drawerId) : null;
        if (!drawer) return;

        const closeButtons = drawer.querySelectorAll('[data-main-product-v2-nutrition-close]');
        const tabs = drawer.querySelectorAll('[data-main-product-v2-nutrition-tab]');
        const panels = drawer.querySelectorAll('[data-main-product-v2-nutrition-panel]');
        const originalParent = drawer.parentNode;
        const originalNextSibling = drawer.nextSibling;
        let closeTimer;
        let isPortaled = false;
        let lockedPageScrollY = 0;

        const setBackgroundInert = (isInert) => {
          Array.from(document.body.children).forEach((child) => {
            if (child === drawer) return;
            if (isInert) {
              child.dataset.mainProductV2NutritionPreviousInert = child.inert ? 'true' : 'false';
              child.inert = true;
            } else if (child.dataset.mainProductV2NutritionPreviousInert !== undefined) {
              child.inert = child.dataset.mainProductV2NutritionPreviousInert === 'true';
              delete child.dataset.mainProductV2NutritionPreviousInert;
            }
          });
        };

        const portalDrawer = () => {
          if (drawer.parentNode === document.body) return;
          document.body.append(drawer);
          isPortaled = true;
        };

        const restoreDrawer = () => {
          if (!isPortaled || !originalParent) return;
          originalParent.insertBefore(drawer, originalNextSibling);
          isPortaled = false;
        };

        const activateTab = (tab) => {
          const tabValue = tab.dataset.mainProductV2NutritionTab;
          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('main_product_v2__nutrition-tab--active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.mainProductV2NutritionPanel !== tabValue;
          });
        };

        const closeDrawer = () => {
          if (drawer.hidden) return;
          drawer.classList.remove('main_product_v2__nutrition-drawer--open');
          window.clearTimeout(closeTimer);
          closeTimer = window.setTimeout(() => {
            drawer.hidden = true;
            setBackgroundInert(false);
            restoreDrawer();
            opener.focus();
          }, 260);
        };

        const openDrawer = () => {
          window.clearTimeout(closeTimer);
          lockedPageScrollY = window.scrollY;
          portalDrawer();
          setBackgroundInert(true);
          drawer.hidden = false;
          window.requestAnimationFrame(() => drawer.classList.add('main_product_v2__nutrition-drawer--open'));
          drawer.querySelector('[data-main-product-v2-nutrition-close]')?.focus();
        };

        const handleKeydown = (event) => {
          if (drawer.hidden) return;
          if (event.key === 'Escape') {
            closeDrawer();
            return;
          }
          if (
            [' ', 'ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End'].includes(event.key)
            && !event.target.closest('.main_product_v2__nutrition-image-wrap')
          ) {
            event.preventDefault();
          }
        };

        const preventBackgroundScroll = (event) => {
          if (drawer.hidden || event.target.closest('.main_product_v2__nutrition-image-wrap')) return;
          event.preventDefault();
        };

        const lockPageScroll = () => {
          if (!drawer.hidden && window.scrollY !== lockedPageScrollY) window.scrollTo(0, lockedPageScrollY);
        };

        opener.addEventListener('click', openDrawer);
        closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
        tabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab)));
        document.addEventListener('keydown', handleKeydown);
        document.addEventListener('wheel', preventBackgroundScroll, { passive: false, capture: true });
        document.addEventListener('touchmove', preventBackgroundScroll, { passive: false, capture: true });
        window.addEventListener('scroll', lockPageScroll, { passive: true });
        opener.dataset.mainProductV2NutritionBound = 'true';

        drawer.__mainProductV2NutritionCleanup = () => {
          window.clearTimeout(closeTimer);
          drawer.hidden = true;
          setBackgroundInert(false);
          restoreDrawer();
          opener.removeEventListener('click', openDrawer);
          closeButtons.forEach((button) => button.removeEventListener('click', closeDrawer));
          document.removeEventListener('keydown', handleKeydown);
          document.removeEventListener('wheel', preventBackgroundScroll, { capture: true });
          document.removeEventListener('touchmove', preventBackgroundScroll, { capture: true });
          window.removeEventListener('scroll', lockPageScroll);
          delete opener.dataset.mainProductV2NutritionBound;
        };
      });
    };

    const start = () => initNutritionDrawers();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();

    if (!window.__mainProductV2NutritionEditorEventsBound) {
      window.__mainProductV2NutritionEditorEventsBound = true;
      document.addEventListener('shopify:section:load', (event) => initNutritionDrawers(event.target));
      document.addEventListener('shopify:section:unload', (event) => {
        event.target.querySelectorAll('[data-main-product-v2-nutrition-drawer]').forEach((drawer) => drawer.__mainProductV2NutritionCleanup?.());
      });
    }
  })();
